export default "__VITE_ASSET__XiVIeZVO__"